export default __webpack_public_path__ + "static/media/plano-recompensa-gimplus.438b02d6.png";